import * as _ from 'es-toolkit';

export function sanitizeStatsParams(params) {
    const source = params || {};
    const sanitized = _.pickBy(source, _.identity);
    if (typeof source.scanned_only === 'boolean')
        sanitized.scanned_only = source.scanned_only;
    return sanitized;
}
